<script setup>
import { VForm } from 'vuetify/components'
import authV2MaskDark from '@/assets/images/pages/auth-v2-mask-dark.png'
import authV2MaskLight from '@/assets/images/pages/auth-v2-mask-light.png'

// import authV2RegisterIllustrationLight from '@/assets/images/pages/auth-v2-register-illustration-light-new.png'
import { useAppAbility } from '@/plugins/casl/useAppAbility'
import AuthProvider from '@/views/pages/authentication/AuthProvider.vue'
import backgroundImage from '@/assets/images/pages/fineDining1.webp'
import axios from '@axios'
import { useGenerateImageVariant } from '@core/composable/useGenerateImageVariant'
import { VNodeRenderer } from '@layouts/components/VNodeRenderer'
import { themeConfig } from '@themeConfig'
import {
  alphaDashValidator,
  emailValidator,
  requiredValidator
} from '@validators'
import { useRoute } from 'vue-router'
import WebsiteNoMenu from "@/layouts/website-no-menu.vue"
import { safeRedirectPath } from '@/utils/safeRedirect'

// Router
const route = useRoute()
const router = useRouter()

const refVForm = ref()
const email = ref(route?.query?.email || '')
console.log('email', email)
const password = ref('')
const termsAccepted = ref(true)

// Ability
const ability = useAppAbility()

// Form Errors
const errors = ref({
  email: undefined,
  password: undefined,
  termsAccepted: undefined
})
const register = () => {
  axios.post('/auth/register', {
    email: email.value,
    password: password.value,
    termsAccepted: termsAccepted.value,
  }).then(r => {
    const {accessToken, userData, userAbilities, jwt} = r.data
    localStorage.setItem('userAbilities', JSON.stringify(userAbilities))
    ability.update(userAbilities)
    localStorage.setItem('userData', JSON.stringify(userData))
    localStorage.setItem('accessToken', JSON.stringify(jwt))
    localStorage.setItem('jwt', JSON.stringify(jwt))
    // C9: validate ?to= against an allowlist before the post-login reload.
    location.href = safeRedirectPath(route.query.to) || '/m'

    return null
  }).catch(e => {
    const {errors: formErrors} = e.response.data
    errors.value = formErrors
    console.error(e.response.data)
  })
}

// const imageVariant = useGenerateImageVariant(authV2RegisterIllustrationLight, true)
const authThemeMask = useGenerateImageVariant(authV2MaskLight, authV2MaskDark)
const isPasswordVisible = ref(false)
const onSubmit = () => {
  refVForm.value?.validate().then(({valid: isValid}) => {
    if (isValid)
      register()
  })
}
</script>

<template>
  <div>
    <div class="full-screen-dark-overlay-image-holder full-screen-dark-overlay-image-holder--dark-gradient">
      <img
        class="full-screen-dark-overlay-image"
        :src="backgroundImage"
      >
    </div>
    <div class="auth-form-holder">
      <VCard
        :max-width="500"
        class="mt-12 mt-sm-0 pa-4"
      >
        <VCardText>
          <!--        <h2 class="reservation-item-restaurant-name"> -->
          <!--          Preferred Reservations -->
          <!--        </h2> -->
          <h1 class="auth-form-title text-center mb-2">
            Welcome RM Members!
          </h1>
          <p class="text-center">
            Register here to activate your account on RM's new website
          </p>
        </VCardText>

        <VCardText>
          <VForm
            ref="refVForm"
            @submit.prevent="onSubmit"
          >
            <VRow>
              <!-- Username -->
              <!--                <VCol cols="12"> -->
              <!--                  <VTextField -->
              <!--                    v-model="username" -->
              <!--                    :rules="[requiredValidator, alphaDashValidator]" -->
              <!--                    label="Username" -->
              <!--                  /> -->
              <!--                </VCol> -->

              <!-- email -->
              <VCol cols="12">
                <VTextField
                  v-model="email"
                  autocomplete="email"
                  :rules="[requiredValidator, emailValidator]"
                  :error-messages="errors.email"
                  label="Email"
                  type="email"
                />
              </VCol>

              <!-- password -->
              <VCol cols="12">
                <VTextField
                  v-model="password"
                  autocomplete="new-password"
                  :rules="[requiredValidator]"
                  :error-messages="errors.password"
                  label="Set Password"
                  :type="isPasswordVisible ? 'text' : 'password'"
                  :append-inner-icon="isPasswordVisible ? 'mdi-eye-off-outline' : 'mdi-eye-outline'"
                  @click:append-inner="isPasswordVisible = !isPasswordVisible"
                />

                <div class="d-flex align-center mt-3">
                  <VCheckbox
                    id="privacy-policy"
                    v-model="termsAccepted"
                    inline
                    :rules="[requiredValidator]"
                    :error-messages="errors.termsAccepted"
                  />
                  <VLabel
                    for="privacy-policy"
                    style="opacity: 1;"
                  >
                    <span class="me-1">I agree to the </span>
                    <a
                      href="/terms"
                      class="text-primary"
                    >terms of service</a>
                  </VLabel>
                </div>

                <VBtn
                  class="mt-6"
                  block
                  type="submit"
                >
                  Register
                </VBtn>
              </VCol>

              <!-- create account -->
              <!--              <VCol -->
              <!--                cols="12" -->
              <!--                class="text-center text-base pt-2 pb-1" -->
              <!--              > -->
              <!--                <span>Already registered?</span> -->
              <!--                <RouterLink -->
              <!--                  class="text-primary ms-2" -->
              <!--                  :to="{ name: 'login' }" -->
              <!--                >Log in -->
              <!--                </RouterLink> -->
              <!--              </VCol> -->
            </VRow>
          </VForm>
        </VCardText>
      </VCard>
    </div>
  </div>
</template>

<style lang="scss">
@use "@core/scss/pages/page-auth.scss";
</style>

<route lang="yaml">
meta:
  layout: website-no-menu
  action: read
  subject: Auth
  redirectIfLoggedIn: true
</route>
